import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { IconModule } from 'ish-core/icon.module';
import { ContentViewHelper } from 'ish-core/models/content-view/content-view.helper';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';

@Component({
  selector: 'ish-cms-navigation-link',
  templateUrl: './cms-navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, IconModule, ServerHtmlDirective],
})
export class CMSNavigationLinkComponent implements CMSComponent {
  readonly pagelet = input.required<ContentPageletView>();

  opened = false;

  isRouterLink = ContentViewHelper.isRouterLink;
  routerLink = ContentViewHelper.getRouterLink;

  subMenuShow(subMenu: HTMLElement) {
    subMenu.classList.add('hover');
  }

  subMenuHide(subMenu: HTMLElement) {
    subMenu.classList.remove('hover');
  }

  toggleOpen() {
    this.opened = !this.opened;
  }
}
